import { Card, CardTitle } from "components/elements";
import { UpdateUserPasswordForm } from "components/form/UpdateUserPassword";

export const SettingsSecurity = () => {
    return (
        <Card>
            <CardTitle>Security Settings</CardTitle>
            <UpdateUserPasswordForm className="mr-auto min-w-[400px]" />
            <div className="h-8" />
        </Card>
    );
};
